import { BaseClient } from '../client';
import { TAnuncio, offersMock } from '../offer';

interface getAdminOffers {
	tagAtivo?: string;
	tagStatus?: string;
	dataCadastroInicial?: string;
	dataCadastroFinal?: string;
}

export const getAllAdminOffers = async (params?: getAdminOffers) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return offersMock;
	// }

	try {
		const response = await BaseClient.post<TAnuncio[]>(`/Admin/GetAdminAnuncios`, params).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
